module.exports = __webpack_public_path__ + "static/media/35.1cab5290.mp3";